import { JSConn } from "@/utilities/js-conn";
import { BASE_URL } from "@/constants";

export default {
  name: "workOrderAttachments",
  data() {
    return {};
  },
  computed: {
    workOrderAttachments: function() {
      return this.$store.getters.workOrderAttachments;
    },
  },
  methods: {
    addHost: function(url) {
      return BASE_URL + url;
    },
    deleteAttachment(attachment) {
      const jsConn = new JSConn();
      jsConn.formParams = attachment;
      this.$store.dispatch("deleteWorkOrderAttachment", jsConn).then(() => {
        this.$emit("attachmentsChanged");
      });
    },
  },
};
